import { Injectable } from '@angular/core';
import { SignalREventService } from './signalr.event.service';

@Injectable()
export class ToastrService {
    public showAlerts = true;

    constructor(private _signalREventService: SignalREventService) {
        this.registerOnServerEvents();
    }

    private onToastrMessage(data: any): void {
        this.displayToastrMessage(data.toastrType, data.message, data.title);
    }

    public displayToastrMessage(toastrType: string, message: string, title: string = null): void {
        if (this.showAlerts || toastrType != 'success') {
            toastr[toastrType](message, title);
        }
    }

    private registerOnServerEvents(): void {
        this._signalREventService.registerAdvanced(this, 'toastrMessage', (data: any) => this.onToastrMessage(data));
    }

    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('ToastrService');
    }
}
